import { Circle, cn, TextField } from "@eisox/design-system";
import { PlusIcon } from "@eisox/icons";

import { m } from "~/paraglide/messages";

interface AddInputProps {
  groupNames: string[];
  onAddGroup: (groupName: string) => void;
  value: string;
  handleChangeValue: (value: string) => void;
  handleFocus: VoidFunction;
}

export const AddInput: React.FC<AddInputProps> = ({
  groupNames,
  onAddGroup,
  value,
  handleChangeValue,
  handleFocus,
}) => {
  const disabled: boolean = groupNames.includes(value) || value === "";

  const addGroup = () => {
    if (!disabled) {
      onAddGroup(value);
      handleChangeValue("");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addGroup();
    }
  };

  return (
    <div className={cn("flex items-center gap-x-[10px]")}>
      <TextField.Root
        className={cn("max-w-[calc(100%-20px)]")}
        value={value}
        onFocus={handleFocus}
        onChange={e => handleChangeValue(e.target.value)}
        placeholder={m.group_name()}
        onKeyDown={handleKeyDown}
      />
      <Circle.Root
        size={20}
        disabled={disabled}
        className={cn(disabled ? "cursor-default" : "cursor-pointer")}
        onClick={() => addGroup()}
        backgroundColor="blue"
        color="white"
      >
        <PlusIcon />
      </Circle.Root>
    </div>
  );
};
